module.exports = __webpack_public_path__ + "static/media/F-3-1.5cae4f7a.webp";